import { render } from "./not-data.vue?vue&type=template&id=4520738f&scoped=true"
import script from "./not-data.vue?vue&type=script&lang=js"
export * from "./not-data.vue?vue&type=script&lang=js"

import "./not-data.vue?vue&type=style&index=0&id=4520738f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4520738f"]])

export default __exports__